import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";
import { getDeviceFingerprint } from "../../utils/fingerprint";
import { getAttribution } from "../../utils/attribution";

const submitReservation = async (
    reservationHead,
    items,
    addonItems,
    event,
    type,
    isPwf,
    token,
    preRegister,
    voucherCode = null,
) => {
    const deviceFingerprint = await getDeviceFingerprint();
    const body = {
        reservationHead,
        event,
        items,
        addonItems,
        type,
        isPwf,
        cart_token: token,
        preRegister: preRegister || null,
        device_fingerprint: deviceFingerprint,
        // The checkout gate (Pay.jsx) blocks submit until all Terms of Purchase
        // are checked, so acceptance is true whenever this request is sent.
        // Recorded server-side as a durable ConsentRecord for dispute evidence.
        accepted_terms: true,
    };
    if (voucherCode) {
        body.voucher_code = voucherCode;
    }
    const attribution = getAttribution();
    if (attribution) {
        body.attribution = attribution;
    }
    const response = await axios.post(
        routes.submitReservation,
        body,
        AXIOS_DEFAULT_CONFIG
    );
    return response;
};
export default submitReservation;